import { typographyClasses } from '@mui/material'

export const leftButtonPrimitives = {
  borderRadius: '2px 0px 0px 2px',
  '&:focus:active': {
    borderRadius: '2px 0px 0px 2px',
    paddingBlock: '0px',
    paddingInline: '12px',
  },
}

export const rightButtonPrimitives = {
  borderRadius: '0px 2px 2px 0px',
  '&:hover': {
    borderRadius: '0px 2px 2px 0px',
  },
  '&:focus:active': {
    borderRadius: '0px 2px 2px 0px',
  },
  height: '100%',
}

export const menuButtonMenuItemPrimitives = {
  [`& .${typographyClasses.root}`]: {
    marginInlineStart: '-18px',
  },
}
